import { inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DeleteDialogComponent } from './components/delete-dialog/dialog.component';

export function deleterWithConfirmation(
  deleter: () => Observable<void>,
  navigateTo: string[],
): () => void {
  const dialog = inject(MatDialog);
  const router = inject(Router);
  const route = inject(ActivatedRoute);
  const cancel = new Subject<void>();
  inject(DestroyRef).onDestroy(() => cancel.next());
  return () =>
    dialog
      .open(DeleteDialogComponent)
      .afterClosed()
      .pipe(takeUntil(cancel))
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          deleter()
            .pipe(takeUntil(cancel))
            .subscribe(() => {
              router.navigate(navigateTo, { relativeTo: route });
            });
        }
      });
}
